import {React, useState }from 'react'
import { Link } from 'react-router-dom';


function SubMenu() {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const [subPagesOpen, setsubPagesOpen] = useState(false);
    const [subShopOpen, setSubShopOpen] = useState(false);
    const [subBlogOpen, setSubBlogOpen] = useState(false);

    const toggleNavigation = () => {
      setNavigationOpen(!navigationOpen);
    };
    const closeNavigation = () => {
        setNavigationOpen(false);
      };
    const toggleSubPages = () => {
        setsubPagesOpen(!subPagesOpen);
      };
    const toggleSubShop = () => {
        setSubShopOpen(!subShopOpen);
      };
      
      const toggleSubBlog = () => {
        setSubBlogOpen(!subBlogOpen);
      };
  return (
    <>
      {navigationOpen && (
        <div className={`nav_inner ${navigationOpen ? 'open' : ''}`}>
          <ul className="main-menu">
            <li className="menu-item">
              <Link to="/" onClick={closeNavigation}>
                Home
              </Link>
            </li>
            <li className="menu-item menu-item-has-children">
              <Link to="" onClick={toggleSubPages}>
                Pages
              </Link>
              {subPagesOpen && (
                <ul className="sub-menu">
                  <li className="menu-item">
                    <Link to="/privacy" onClick={closeNavigation}>
                      Privacy
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/payment" onClick={closeNavigation}>
                      Payments
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/order" onClick={closeNavigation}>
                      Order
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/order-details" onClick={closeNavigation}>
                      Order Details
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/checkout" onClick={closeNavigation}>
                      Checkout
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/error" onClick={closeNavigation}>
                      Error Page
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/thankyou" onClick={closeNavigation}>
                      Thank You Page
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li className="menu-item menu-item-has-children">
              <Link to="#" onClick={toggleSubShop}>
                Shop
              </Link>
              {subShopOpen && (
                <ul className="sub-menu">
                  <li className="menu-item">
                    <Link to="/shop" onClick={closeNavigation}>
                      Shop
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/shop-details" onClick={closeNavigation}>
                      Shop Detail
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li className="menu-item menu-item-has-children">
              <Link to="#" onClick={toggleSubBlog}>
                Blog
              </Link>
              {subBlogOpen && (
                <ul className="sub-menu">
                  <li className="menu-item">
                    <Link to="/blog" onClick={closeNavigation}>
                      Blog
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/blog-details" onClick={closeNavigation}>
                      Blog Details
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/blog-left" onClick={closeNavigation}>
                      Blog Left Sidebar
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/blog-right" onClick={closeNavigation}>
                      Blog Right Sidebar
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li className="menu-item">
              <Link to="/about" onClick={closeNavigation}>
                About Us
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/faqs" onClick={closeNavigation}>
                FAQ
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/terms-conditions" onClick={closeNavigation}>
                T&C
              </Link>
            </li>

            <li className="menu-item">
              <Link to="/contact" onClick={closeNavigation}>
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      )}

      <button className={`hamburger ${navigationOpen ? 'cross' : ''}`}  onClick={toggleNavigation}>
          <div className="hamburger_btn">
            <span></span>
            <span></span>
            <span></span>
          </div>
      </button>
    </>
  );
}

export default SubMenu